<div class="content">
  <div class="content-panel">
    <div *ngIf="historiques">
      <h2 translate>page.declarations.historique-mouvements.title</h2>

      <!-- Bloc filtre -->
      <div class="card shadow-sm mb-4">
        <div class="card-body">
          <h5 class="card-title mb-3">Recherche avancée</h5>

          <form
            [formGroup]="formRecherche"
            #form="ngForm"
            (ngSubmit)="onSubmit()"
          >
            <div class="row g-3 align-items-end">
              <!-- Année de déclaration -->
              <div class="col-12 col-md-6 col-lg-2">
                <label class="form-label" for="anneeDeclaration" translate>
                  page.declarations.historique-mouvements.table.header.anneeDeclaration
                </label>
                <input
                  id="anneeDeclaration"
                  formControlName="anneeDeclaration"
                  maxlength="4"
                  class="form-control"
                />
              </div>

              <!-- Millésime -->
              <div class="col-12 col-md-6 col-lg-2">
                <label class="form-label" for="millesime" translate>
                  page.declarations.historique-mouvements.table.header.annee
                </label>
                <input
                  id="millesime"
                  formControlName="millesime"
                  maxlength="4"
                  class="form-control"
                />
              </div>

              <!-- Cahier des charges -->
              <div class="col-12 col-md-6 col-lg-4">
                <label class="form-label" for="cdc" translate>
                  page.declarations.historique-mouvements.form.cdc
                </label>
                <div *ngIf="cahiers">
                  <app-multiselect
                    id="cdc"
                    controlName="cdc"
                    [items]="cahiers"
                    bindLabel="libelle"
                    maxWidth="initial"
                    class="w-100"
                  >
                  </app-multiselect>
                </div>
              </div>

              <!-- Type déclaration -->
              <div class="col-12 col-md-6 col-lg-4">
                <label class="form-label" for="typeDeclatation" translate>
                  page.declarations.historique-mouvements.form.typeDeclaration
                </label>
                <div *ngIf="referentiel?.refMouvements">
                  <app-multiselect
                    id="typeDeclatation"
                    controlName="typeDeclatation"
                    [items]="referentiel.refMouvements"
                    bindLabel="libelle"
                    maxWidth="initial"
                    class="w-100"
                  >
                  </app-multiselect>
                </div>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-12 d-flex flex-wrap justify-content-end gap-2">
                <button type="submit" class="btn btn-primary" translate>
                  label.filtrer
                </button>

                <button
                  type="button"
                  class="btn btn-outline-secondary"
                  (click)="formRecherche.reset()"
                >
                  Réinitialiser
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <!-- Tableau -->
      <div class="table-responsive">
        <table class="table table-striped align-middle" aria-label="Liste des historiques" *ngIf="displayedHistoriques?.length > 0">
          <thead>
            <tr>
              <th *ngFor="let column of columns">
                <span translate>{{ column.label }}</span>
              </th>
              <th class="text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let historique of displayedHistoriques">
              <td *ngFor="let column of columns" class="column-max-width">
                <ng-container [ngSwitch]="column.field">
                  <span *ngSwitchCase="'dateDebut'">
                    {{ historique.dateDebut | date:'dd/MM/yyyy' }}
                  </span>

                  <span *ngSwitchCase="'typeDeclaration'">
                    {{ getTypeMouvement(historique.code) }}
                  </span>

                  <span *ngSwitchCase="'annee'">
                    {{ historique.annee }}
                  </span>

                  <span *ngSwitchCase="'produit'">
                    {{ historique.produit?.libelle }}
                  </span>

                  <span *ngSwitchCase="'volumeTotal'">
                    {{ historique.volume | number:'1.2-2' }}
                  </span>

                  <span *ngSwitchCase="'dateMouvement'">
                    {{ historique.dateMouvement | date:'dd/MM/yyyy' }}
                  </span>

                  <span *ngSwitchCase="'logementLot'">
                    <ng-container *ngIf="historique.logement || historique.numeroLot">
                      {{ historique.logement }} / {{ historique.numeroLot }}
                    </ng-container>
                  </span>

                  <span *ngSwitchCase="'etat'" translate>
                    {{ getEtat(historique) }}
                  </span>

                  <span *ngSwitchCase="'numeroDossier'">
                    {{ historique.numeroDossier }}
                  </span>

                  <span *ngSwitchDefault>
                    {{ historique[column.field] }}
                  </span>
                </ng-container>
              </td>

              <td class="text-center text-nowrap">
                <button
                  type="button"
                  class="btn btn-link p-0 me-3"
                  (click)="onEdit(historique)"
                  title="Voir"
                >
                  <fa-icon icon="eye"></fa-icon>
                </button>

                <button
                  type="button"
                  class="btn btn-link p-0"
                  (click)="telechargerDocument(historique)"
                  title="Télécharger"
                >
                  <fa-icon icon="download"></fa-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Aucun résultat -->
  <ng-container *ngIf="hasResult && displayedHistoriques?.length === 0">
    <div class="alert alert-warning alert-block" translate>
      <fa-icon icon="exclamation"></fa-icon>
      page.declarations.historique-mouvements.aucunHistorique
    </div>
  </ng-container>
</div>
